import apiClient from '../config/axiosConfig.js';

/**
 * Kick off a server-side split of an audio file into WAV segments.
 *
 * @param {string} sourceFileId
 * @param {Array<{start:number,end:number,name?:string}>} segments
 * @param {{ discardOriginal?: boolean, groupName?: string }} [options]
 * @returns {Promise<{ success: boolean, jobId: string }>}
 */
export async function requestSplit(sourceFileId, segments, options = {}) {
    const res = await apiClient.post('/api/audio/split', {
        sourceFileId,
        segments,
        discardOriginal: !!options.discardOriginal,
        groupName: options.groupName,
    });
    return res.data;
}

/** Poll a split job's progress. Returns the SplitJob doc. */
export async function getSplitStatus(jobId) {
    const res = await apiClient.get('/api/audio/split/status', { params: { jobId } });
    return res.data.job;
}

/**
 * Fetch precomputed waveform peaks for a (large) audio file.
 * @returns {Promise<{ success: boolean, peaks: number[], duration: number }>}
 */
export async function getPeaks(fileId) {
    const res = await apiClient.get('/api/audio/peaks', { params: { id: fileId } });
    return res.data;
}
